<div class="p-grid">
    <!--Tipos de organización-->
            <div class="p-col-11 p-field">
            <label for="name">Nombre</label>
            <input pInputText type="text" name="name" [(ngModel)]="organizationType.name">
        </div>
        <div class="p-col-1 p-field">
            <label for="color">Color</label>
            <p-colorPicker name="color" [(ngModel)]="organizationType.color" appendTo="body"></p-colorPicker>
        </div>
    <!--Opciones-->
    <div class="p-col-12">
        <button pButton class="p-button-danger" *ngIf="organizationType.id>0" (click)="delete()" icon="pi pi-trash"
            label="Eliminar"></button>
        <button pButton class="p-ml-2" style="float: right;" (click)="isDuplied()" icon="pi pi-check"
            label="Guardar"></button>
        <button pButton class="p-button-secondary p-button-text" style="float: right;" (click)="cancel()" icon="pi pi-times"
            label="Cancelar"></button>
    </div>
</div>